import { Button } from '@mui/material';
import { styled } from 'styled-components';

import CommonButtonDelete from '../../Common/ButtonDelete';

export const ButtonDelete = styled(CommonButtonDelete)`
  padding: var(--spacing-small) 0;
`;

export const MuiButton = styled(Button)`
  padding: var(--spacing-small) var(--spacing-medium);

  /* stylelint-disable-next-line selector-class-pattern */
  .MuiButtonBase-root {
    justify-content: flex-start;
  }
`;
